import * as THREE from "three";

export type DaylightRigConfig = {
  ambientColor?: number;
  ambientIntensity?: number;
  keyColor?: number;
  keyIntensity?: number;
  keyPosition?: THREE.Vector3;
  fillColor?: number;
  fillIntensity?: number;
  fillPosition?: THREE.Vector3;
};

const DEFAULT_CONFIG: Required<Omit<DaylightRigConfig, "keyPosition" | "fillPosition">> = {
  ambientColor: 0xaebd9f,
  ambientIntensity: 0.92,
  keyColor: 0xfff3d6,
  keyIntensity: 1.65,
  fillColor: 0x6d8daa,
  fillIntensity: 0.46,
};

export class DaylightRig {
  readonly ambient: THREE.AmbientLight;
  readonly key: THREE.DirectionalLight;
  readonly fill: THREE.DirectionalLight;

  constructor(
    private readonly scene: THREE.Scene,
    config: DaylightRigConfig = {},
  ) {
    const merged = { ...DEFAULT_CONFIG, ...config };
    const keyPosition = (config.keyPosition ?? new THREE.Vector3(320, 520, 210)).clone();
    const fillPosition = (config.fillPosition ?? new THREE.Vector3(-220, 280, -160)).clone();

    this.ambient = new THREE.AmbientLight(merged.ambientColor, merged.ambientIntensity);

    this.key = new THREE.DirectionalLight(merged.keyColor, merged.keyIntensity);
    this.key.position.copy(keyPosition);
    this.key.castShadow = true;
    this.key.shadow.mapSize.set(2048, 2048);
    this.key.shadow.camera.near = 10;
    this.key.shadow.camera.far = 1400;
    this.key.shadow.camera.left = -700;
    this.key.shadow.camera.right = 700;
    this.key.shadow.camera.top = 700;
    this.key.shadow.camera.bottom = -700;
    this.key.shadow.bias = -0.0004;

    this.fill = new THREE.DirectionalLight(merged.fillColor, merged.fillIntensity);
    this.fill.position.copy(fillPosition);

    this.scene.add(this.ambient, this.key, this.fill);
  }

  dispose(): void {
    this.scene.remove(this.ambient, this.key, this.fill);
  }
}
